package com.patronat.top.client.presentation.auth

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.molecules.inputs.AppOtpInput
import com.patronat.top.ui.theme.BodyLarge
import com.patronat.top.ui.theme.MineShaft600
import com.patronat.top.ui.theme.OnboardingTitleText
import com.patronat.top.dto.AuthFlow
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.auth_login_action
import top.clientapp.generated.resources.auth_register_action
import top.clientapp.generated.resources.auth_verify_phone_subtitle
import top.clientapp.generated.resources.auth_verify_phone_title

@Composable
internal fun ClientVerifyPhoneContent(
    state: ClientAuthViewState,
    onEvent: (ClientAuthEvent) -> Unit,
    modifier: Modifier = Modifier
) {
    var codeValue by remember { mutableStateOf("") }
    var timeLeft by remember { mutableIntStateOf(59) }

    LaunchedEffect(state.otpTimerKey) {
        codeValue = ""
        timeLeft = 59

        while (timeLeft > 0) {
            delay(1_000L)
            timeLeft -= 1
        }
    }

    val timerText = remember(timeLeft) {
        val minutes = timeLeft / 60
        val seconds = timeLeft % 60
        "${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}"
    }

    Column(
        modifier = modifier
            .fillMaxSize()
            .widthIn(max = 420.dp)
            .padding(horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Spacer(modifier = Modifier.height(18.dp))

        ClientAuthBackHeader(
            onBackClick = { onEvent(ClientAuthEvent.OnBackClicked) }
        )

        Spacer(modifier = Modifier.height(8.dp))

        Text(
            text = stringResource(Res.string.auth_verify_phone_title),
            style = OnboardingTitleText
        )

        Spacer(modifier = Modifier.height(8.dp))

        Text(
            text = stringResource(Res.string.auth_verify_phone_subtitle),
            style = BodyLarge.copy(
                color = MineShaft600,
                textAlign = TextAlign.Center
            ),
            modifier = Modifier.widthIn(max = 290.dp)
        )

        Spacer(modifier = Modifier.height(26.dp))

        AppOtpInput(
            value = codeValue,
            onValueChange = { codeValue = it },
            timerText = timerText,
            errorText = state.otpError?.asString(),
            onResendClick = {
                if (timeLeft == 0) {
                    onEvent(ClientAuthEvent.OnResendPhoneCode)
                }
            }
        )

        Spacer(modifier = Modifier.weight(1f))

        AppButton(
            text = stringResource(
                if (state.flow == AuthFlow.LOGIN) {
                    Res.string.auth_login_action
                } else {
                    Res.string.auth_register_action
                }
            ),
            onClick = { onEvent(ClientAuthEvent.OnSubmitPhoneCode(codeValue)) },
            modifier = Modifier.fillMaxWidth(),
            type = ButtonType.Black,
            enabled = codeValue.length == 6,
            isLoading = state.isLoading
        )

        Spacer(modifier = Modifier.height(30.dp))
    }
}
